import FormularioPrestador from './ModalPrestador';

export default FormularioPrestador;